import React from "react";
import Loading from "@acadia-ui/loading";

// defaulted to fullscreen, consumer can override with it's own props.
export default (props) => <Loading {...props} />;
